// src/components/RunningTallyS2.tsx
// ─────────────────────────────────────────────────────────────────────────────
// Running Tally — Session 2 (Business Engine)
// Same pinned-bar pattern as S1 RunningTally, different metrics.
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';

export interface TallyS2Props {
  additionalProfitMonthly: number;
  ctSavedAnnual: number;
  ctSavedCumulative: number;
  pensionFundedMonthly: number;
  freedomAgeImprovement: number;
}

const fmt = (n: number) => {
  if (n === 0) return '£0';
  return '£' + Math.round(n).toLocaleString();
};

const RunningTallyS2: React.FC<TallyS2Props> = ({
  additionalProfitMonthly,
  ctSavedAnnual,
  ctSavedCumulative,
  pensionFundedMonthly,
  freedomAgeImprovement,
}) => {
  const freedomLabel = freedomAgeImprovement > 0
    ? `${freedomAgeImprovement.toFixed(1)} yrs earlier`
    : '—';

  return (
    <div
      className="w-full flex-shrink-0"
      style={{ background: '#1B2B4B' }}
    >
      <div className="px-6 py-2.5 flex items-center justify-between gap-6 overflow-x-auto">
        {/* Label */}
        <div className="text-white/60 text-xs font-medium whitespace-nowrap flex-shrink-0">
          Business impact:
        </div>

        {/* Figures */}
        <div className="flex items-center gap-6 text-xs whitespace-nowrap">
          <div className="flex items-center gap-1.5">
            <span className="text-white/70">Additional profit</span>
            <span className="font-bold" style={{ color: '#C9A84C' }}>{fmt(additionalProfitMonthly)}/mo</span>
          </div>

          <div className="text-white/30">|</div>

          <div className="flex items-center gap-1.5">
            <span className="text-white/70">CT saved/yr</span>
            <span className="font-bold" style={{ color: '#C9A84C' }}>{fmt(ctSavedAnnual)}</span>
          </div>

          <div className="text-white/30">|</div>

          <div className="flex items-center gap-1.5">
            <span className="text-white/70">CT saved total</span>
            <span className="font-bold" style={{ color: '#C9A84C' }}>{fmt(ctSavedCumulative)}</span>
          </div>

          <div className="text-white/30">|</div>

          <div className="flex items-center gap-1.5">
            <span className="text-white/70">Pension funded</span>
            <span className="font-bold" style={{ color: '#C9A84C' }}>{fmt(pensionFundedMonthly)}/mo</span>
          </div>

          <div className="text-white/30">|</div>

          <div className="flex items-center gap-1.5">
            <span className="text-white/70">Freedom age</span>
            <span className="font-bold" style={{ color: '#C9A84C' }}>{freedomLabel}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RunningTallyS2;
